export function getPrintQuality({
  img,
  canvas,
  grid,
  scale
}) {
  if (!img || !canvas) return null;

  const realPieceWidth =
    (canvas.width / grid.cols) / scale;

  const realPieceHeight =
    (canvas.height / grid.rows) / scale;

  const minPixels = Math.min(
    realPieceWidth,
    realPieceHeight
  );

  return minPixels >= 150 ? "good" : "bad";
}
